import { z } from "zod";

import { publicEnv } from "@/lib/public-env";
import { mudwaterNetwork } from "@/lib/mudwater";

// Read the deployment snapshot before constructing any connector or provider.
const raw = {
  privyAppId: publicEnv("NEXT_PUBLIC_MUDWATER_PRIVY_APP_ID") ?? "",
  privyClientId: publicEnv("NEXT_PUBLIC_MUDWATER_PRIVY_CLIENT_ID") ?? "",
  walletConnectProjectId:
    publicEnv("NEXT_PUBLIC_MUDWATER_WALLETCONNECT_PROJECT_ID") ?? "",
};

/**
 * Privy throws during render on a malformed app ID rather than degrading, and
 * CI builds with no environment at all, so the length rule is enforced here and
 * the provider is simply not mounted when it fails.
 */
export const privyAppIdSchema = z.string().length(25);

export const privyAppId = raw.privyAppId;
export const privyClientId = raw.privyClientId;
export const walletConnectProjectId = raw.walletConnectProjectId;

export const isPrivyConfigured = privyAppIdSchema.safeParse(
  raw.privyAppId
).success;

/** RainbowKit's default config requires a project ID; without one we fall back
 * to injected wallets only rather than failing the build. */
export const isWalletConnectConfigured = raw.walletConnectProjectId.length > 0;

/** Privy defaults transaction signing to mainnet, so this is always passed.
 * Privy does not re-export its `SolanaChain` union, so this infers the two
 * literals it needs rather than asserting against an unexported type. */
export const solanaChain =
  mudwaterNetwork === "devnet" ? "solana:devnet" : "solana:mainnet";
